import type { Brand } from "@shared/brand.types";
import { fetchJson, HttpError } from "./http";

/** La marque, plus ce que le serveur sait faire aujourd'hui. */
export type BrandView = Brand & { extractionAvailable?: boolean };

/**
 * `null` veut dire « ce slug n'ouvre aucune page », et l'écran affiche alors son état
 * « école inconnue ».
 *
 * ⚠️ Une coupure, un délai dépassé et une PANNE DU SERVEUR remontent au lieu de rendre
 * `null` : aucun des trois ne dit que l'école n'existe pas, et la page publique d'une
 * école bien réelle ne doit pas se transformer en « ce lien ne correspond à aucune
 * école » parce que le wifi a sauté ou que la base est tombée. Le 5xx manquait à cette
 * liste, et c'est le plus fréquent des trois.
 */
export async function fetchBrand(slug: string): Promise<BrandView | null> {
	try {
		return await fetchJson<BrandView>(`/api/brand/${encodeURIComponent(slug)}`);
	} catch (error) {
		const status = error instanceof HttpError ? error.status : null;
		if (status !== null && status < 500) return null;
		throw error;
	}
}

export type MyRequest = {
	id: string;
	schoolName: string;
	job: string;
	location: string | null;
	contract: string | null;
	status: string;
	createdAt: string;
};
